import { Box, Text } from '@domain-group/suit-theme'

import IntegrationPlatformLogo from '@components/IntegrationPlatformLogo'

type IntegrationPlatformProps = {
  integrationPlatform: { title: string },
}

const IntegrationPlatform = (props: IntegrationPlatformProps) => {
  const { integrationPlatform } = props

  const { title } = integrationPlatform

  return (
    <Box>
      <Box
        alignItems="center"
        backgroundColor="whiteGrey"
        border="1px solid"
        borderRadius={5}
        borderColor="lineColor"
        justifyContent="center"
        width={100}
      >
        <IntegrationPlatformLogo
          integrationPlatformKey="my_property_pass"
          imageProps={{ height: 60, width: '100%', backgroundSize: 'contain' }}
        />
      </Box>

      <Box justifyContent="center" flexDirection="column" padding="large">
        <Text fontSize="medium">{title}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" lineHeight={1.3} marginTop="medium">
          Integration Platform
        </Text>
      </Box>
    </Box>
  )
}

export default IntegrationPlatform
